export function canDownloadItineraryPdf(itinerary) {
    return itinerary?.id !== undefined && itinerary.id !== null;
}
